import * as React from 'react';
import { map } from 'lodash';

import { splitSymbols } from './string-helpers';

interface IWrapSymbolProps {
  string: string;
  wrapper: React.FC;
  symbols?: RegExp;
}

const WrapSymbol: React.FC<IWrapSymbolProps> = ({ string, wrapper, symbols = undefined }) => {
  const split = splitSymbols(string, symbols);
  const Wrapper = wrapper;

  return (
    <>
      {map(split, ({ text, isSymbol }, i) =>
        isSymbol && text ? (
          <Wrapper key={`${text}${i}`}>{text}</Wrapper>
        ) : (
          <React.Fragment key={`${text}${i}`}>{text}</React.Fragment>
        ),
      )}
    </>
  );
};

export default WrapSymbol;
